// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.success-btn {
  position: absolute;
  left: 1rem;
  top: 1rem;
  background: #ffb369;
  padding: 0.5rem 2rem;
  border-radius: 2px;
  color: white;
  
}

figure {
  display: flex;
  align-items: center;
  justify-content: center;
}
.w-full {
  width: 100%;
}

.submitted-animation {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

.submit-wrapper {
    overflow: visible;
}

.submit,
.loader,
.loader-wrapper {
    position:absolute;
    left:0;
    right:0;
    margin:0 auto;
}

.submit {
    z-index: 2;
    width: 325px;
    letter-spacing: 6px;
    height: 70px;
    background: linear-gradient(to right, #ffb369 0%, #ff4272 100%);
    border-radius: 200px;
    text-align: center;
    color: rgba(255,255,255,1);
    text-decoration: none;
    transition:  all 0.7s ease, color 0.4s ease, filter 0.2s ease;
  cursor: pointer;
    display: flex;
  align-items: center;
  justify-content: center;

    &:not([disabled]) {
        &:before,
        &:after {
            content: "";
            width: 100%;
            height: 100%;
            border-radius: 200px;
            position: absolute;
            left: 0;
            top: 0;
            display: block;
            background: linear-gradient(to right, #ffb369 0%, #ff4272 100%);
        }

        &:before {
            z-index: -2;
            opacity: 0.8;
            transform: scale(0.9) translateY(15px);
            filter: blur(20px);
            transition: all 0.2s ease;
        }

        &:after {
            z-index:-4;
            opacity:0;
            transform:scale(1);
        }
    }
}

.submit-wrapper::selection,
.submit::selection {
    background: transparent;
}

.progress {
    filter: url("#goo");
}


.yellow {
    background-color: #ffb369;
}

.pink {
    background-color: #ff4272;
}

.orange {
    background-color: #ff7b6e;
    transform: scale(0.2) rotate(30deg) translate(0px);
}

.loader {
  width: 95px;
  height: 95px;
  border-radius: 100%;
  opacity: 0;
  z-index: 1;
}

.progress,
.success {
    .loader {
        opacity: 1;
    }

    .loader-wrapper {
        width: 95px;
        height: 95px;
        transform: scale(0);
    }

    .submit {
        width: 65px;
        height: 65px;
        padding: 0 !important;
        color: transparent;
        background: linear-gradient(to right, #23d223 0%, #23d223 100%);
    }

    .submit:before {
        top: 0;
        opacity: 0;
    }
    .check-wrapper {
        z-index: 3;
    }
}

.progress {
    .loader-wrapper {
        animation: wrapper-loader-anim 4.2s linear infinite;
    }

    .submit {
        animation: submit-anim 4s cubic-bezier(0.39, 0.575, 0.565, 1) infinite;
    }

    .pink {
        animation: loader-anim-pink 4s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
    }

    .yellow  {
        animation: loader-anim-yellow 4s 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
    }

    .orange {
        animation: loader-anim-orange 4s 0.7s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;
    }
}

.success {
    .check {
        animation: check 4s ease forwards;
    }
}

.check-wrapper {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 65px;
    height: 65px;
    z-index: -1;
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 50%;
        height: 50%;
    }
}


.check {
    fill: none;
    stroke: white;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 2;
    stroke-dasharray:  1000;
    stroke-dashoffset:  1000;
    z-index: -1;
}


@keyframes loader-anim-pink {
    0% {
        transform:scale(0.2) rotate(0deg) translate(220px, 0px);
    }
    100% {
        transform:scale(0.2) rotate(1100deg) translate(300px, 0px);
    }
}

@keyframes loader-anim-yellow {
    0% {
        transform:scale(0.2) rotate(0deg) translate(300px, 0px);
    }
    100% {
        transform:scale(0.2) rotate(1100deg) translate(220px, 0px);
    }
}

@keyframes loader-anim-orange {
    0%,
    70% {
        transform:scale(0.2) rotate(30deg) translate(0px);
    }
    85% {
        transform:scale(0.2) rotate(30deg) translate(-300px);
    }
    100% {
        transform:scale(0.2) rotate(30deg) translate(0px);
    }
}

@keyframes wrapper-loader-anim {
    0% {
        transform: scale(0) translateY(0px) ;
    }
    10% {
        transform: scale(1) translateY(20px);
    }
    50% {
        transform: scale(1.2) translateY(10px) ;
    }
    90% {
        transform: scale(1) translateY(-10px);
    }
    100% {
        transform: scale(0) translateY(0px);
    }
}

@keyframes submit-after-anim {
    0% {
        transform: scale(1);
        opacity: 0.3;
    }
    100% {
        transform: scale(2);
        opacity: 0;
    }
}

@keyframes submit-anim {
    0% {
        transform: scale(1) ;
    }
    5%,
    95% {
        transform: scale(0.7) ;
    }
    100% {
        transform: scale(1);
    }
}

@keyframes check {
  from {
    stroke-dashoffset: 1000;
  }
  to {
    stroke-dashoffset: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/submit-button.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;;AAEd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;IAGI,iBAAiB;IACjB,MAAM;IACN,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,+DAA+D;IAC/D,oBAAoB;IACpB,kBAAkB;IAClB,0BAA0B;IAC1B,qBAAqB;IACrB,6DAA6D;EAC/D,eAAe;IACb,aAAa;EACf,mBAAmB;EACnB,uBAAuB;;IAErB;QACI;;YAEI,WAAW;YACX,WAAW;YACX,YAAY;YACZ,oBAAoB;YACpB,kBAAkB;YAClB,OAAO;YACP,MAAM;YACN,cAAc;YACd,+DAA+D;QACnE;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,sCAAsC;YACtC,kBAAkB;YAClB,yBAAyB;QAC7B;;QAEA;YACI,UAAU;YACV,SAAS;YACT,kBAAkB;QACtB;IACJ;AACJ;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,UAAU;AACZ;;AAEA;;IAEI;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,qBAAqB;QACrB,kBAAkB;QAClB,+DAA+D;IACnE;;IAEA;QACI,MAAM;QACN,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,mDAAmD;IACvD;;IAEA;QACI,sEAAsE;IAC1E;;IAEA;QACI,4EAA4E;IAChF;;IAEA;QACI,mFAAmF;IACvF;;IAEA;QACI,mFAAmF;IACvF;AACJ;;AAEA;IACI;QACI,iCAAiC;IACrC;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;QACI,UAAU;QACV,WAAW;IACf;AACJ;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,oBAAoB;IACpB,uBAAuB;IACvB,wBAAwB;IACxB,WAAW;AACf;;;AAGA;IACI;QACI,uDAAuD;IAC3D;IACA;QACI,0DAA0D;IAC9D;AACJ;;AAEA;IACI;QACI,uDAAuD;IAC3D;IACA;QACI,0DAA0D;IAC9D;AACJ;;AAEA;IACI;;QAEI,iDAAiD;IACrD;IACA;QACI,oDAAoD;IACxD;IACA;QACI,iDAAiD;IACrD;AACJ;;AAEA;IACI;QACI,oCAAoC;IACxC;IACA;QACI,oCAAoC;IACxC;IACA;QACI,uCAAuC;IAC3C;IACA;QACI,qCAAqC;IACzC;IACA;QACI,mCAAmC;IACvC;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,YAAY;IAChB;IACA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;IACA;;QAEI,sBAAsB;IAC1B;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".success-btn {\n  position: absolute;\n  left: 1rem;\n  top: 1rem;\n  background: #ffb369;\n  padding: 0.5rem 2rem;\n  border-radius: 2px;\n  color: white;\n  \n}\n\nfigure {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.w-full {\n  width: 100%;\n}\n\n.submitted-animation {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.submit-wrapper {\n    overflow: visible;\n}\n\n.submit,\n.loader,\n.loader-wrapper {\n    position:absolute;\n    left:0;\n    right:0;\n    margin:0 auto;\n}\n\n.submit {\n    z-index: 2;\n    width: 325px;\n    letter-spacing: 6px;\n    height: 70px;\n    background: linear-gradient(to right, #ffb369 0%, #ff4272 100%);\n    border-radius: 200px;\n    text-align: center;\n    color: rgba(255,255,255,1);\n    text-decoration: none;\n    transition:  all 0.7s ease, color 0.4s ease, filter 0.2s ease;\n  cursor: pointer;\n    display: flex;\n  align-items: center;\n  justify-content: center;\n\n    &:not([disabled]) {\n        &:before,\n        &:after {\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            border-radius: 200px;\n            position: absolute;\n            left: 0;\n            top: 0;\n            display: block;\n            background: linear-gradient(to right, #ffb369 0%, #ff4272 100%);\n        }\n\n        &:before {\n            z-index: -2;\n            opacity: 0.8;\n            transform: scale(0.9) translateY(15px);\n            filter: blur(20px);\n            transition: all 0.2s ease;\n        }\n\n        &:after {\n            z-index:-4;\n            opacity:0;\n            transform:scale(1);\n        }\n    }\n}\n\n.submit-wrapper::selection,\n.submit::selection {\n    background: transparent;\n}\n\n.progress {\n    filter: url(\"#goo\");\n}\n\n\n.yellow {\n    background-color: #ffb369;\n}\n\n.pink {\n    background-color: #ff4272;\n}\n\n.orange {\n    background-color: #ff7b6e;\n    transform: scale(0.2) rotate(30deg) translate(0px);\n}\n\n.loader {\n  width: 95px;\n  height: 95px;\n  border-radius: 100%;\n  opacity: 0;\n  z-index: 1;\n}\n\n.progress,\n.success {\n    .loader {\n        opacity: 1;\n    }\n\n    .loader-wrapper {\n        width: 95px;\n        height: 95px;\n        transform: scale(0);\n    }\n\n    .submit {\n        width: 65px;\n        height: 65px;\n        padding: 0 !important;\n        color: transparent;\n        background: linear-gradient(to right, #23d223 0%, #23d223 100%);\n    }\n\n    .submit:before {\n        top: 0;\n        opacity: 0;\n    }\n    .check-wrapper {\n        z-index: 3;\n    }\n}\n\n.progress {\n    .loader-wrapper {\n        animation: wrapper-loader-anim 4.2s linear infinite;\n    }\n\n    .submit {\n        animation: submit-anim 4s cubic-bezier(0.39, 0.575, 0.565, 1) infinite;\n    }\n\n    .pink {\n        animation: loader-anim-pink 4s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;\n    }\n\n    .yellow  {\n        animation: loader-anim-yellow 4s 0.2s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;\n    }\n\n    .orange {\n        animation: loader-anim-orange 4s 0.7s cubic-bezier(0.645, 0.045, 0.355, 1) infinite;\n    }\n}\n\n.success {\n    .check {\n        animation: check 4s ease forwards;\n    }\n}\n\n.check-wrapper {\n    position: absolute;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    width: 65px;\n    height: 65px;\n    z-index: -1;\n    opacity: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    svg {\n        width: 50%;\n        height: 50%;\n    }\n}\n\n\n.check {\n    fill: none;\n    stroke: white;\n    stroke-width: 2;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    stroke-miterlimit: 2;\n    stroke-dasharray:  1000;\n    stroke-dashoffset:  1000;\n    z-index: -1;\n}\n\n\n@keyframes loader-anim-pink {\n    0% {\n        transform:scale(0.2) rotate(0deg) translate(220px, 0px);\n    }\n    100% {\n        transform:scale(0.2) rotate(1100deg) translate(300px, 0px);\n    }\n}\n\n@keyframes loader-anim-yellow {\n    0% {\n        transform:scale(0.2) rotate(0deg) translate(300px, 0px);\n    }\n    100% {\n        transform:scale(0.2) rotate(1100deg) translate(220px, 0px);\n    }\n}\n\n@keyframes loader-anim-orange {\n    0%,\n    70% {\n        transform:scale(0.2) rotate(30deg) translate(0px);\n    }\n    85% {\n        transform:scale(0.2) rotate(30deg) translate(-300px);\n    }\n    100% {\n        transform:scale(0.2) rotate(30deg) translate(0px);\n    }\n}\n\n@keyframes wrapper-loader-anim {\n    0% {\n        transform: scale(0) translateY(0px) ;\n    }\n    10% {\n        transform: scale(1) translateY(20px);\n    }\n    50% {\n        transform: scale(1.2) translateY(10px) ;\n    }\n    90% {\n        transform: scale(1) translateY(-10px);\n    }\n    100% {\n        transform: scale(0) translateY(0px);\n    }\n}\n\n@keyframes submit-after-anim {\n    0% {\n        transform: scale(1);\n        opacity: 0.3;\n    }\n    100% {\n        transform: scale(2);\n        opacity: 0;\n    }\n}\n\n@keyframes submit-anim {\n    0% {\n        transform: scale(1) ;\n    }\n    5%,\n    95% {\n        transform: scale(0.7) ;\n    }\n    100% {\n        transform: scale(1);\n    }\n}\n\n@keyframes check {\n  from {\n    stroke-dashoffset: 1000;\n  }\n  to {\n    stroke-dashoffset: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
